/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Carousel_NextInputs */

const id_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide berikutnya`)
};

const ms_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slaid seterusnya`)
};

const da_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste slide`)
};

const de_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste Folie`)
};

const en_us2_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const es_es2_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva siguiente`)
};

const es_mx2_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva siguiente`)
};

const fil_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunod na slide`)
};

const fr_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositive suivante`)
};

const it_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide successiva`)
};

const hu_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Következő dia`)
};

const nl_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende dia`)
};

const no_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neste lysbilde`)
};

const pl_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następny slajd`)
};

const pt_br2_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const pt_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide seguinte`)
};

const ro_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide următor`)
};

const fi_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava dia`)
};

const sv_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa bild`)
};

const vi_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang trình chiếu tiếp`)
};

const tr_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki slayt`)
};

const cs_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další snímek`)
};

const bg_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следващ слайд`)
};

const ru_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий слайд`)
};

const uk_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наступний слайд`)
};

const ar_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الشريحة التالية`)
};

const hi_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगली स्लाइड`)
};

const th_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สไลด์ถัดไป`)
};

const ja_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のスライド`)
};

const zh_cn2_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const zh_hant1_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

const ko_ui_carousel_next = /** @type {(inputs: Ui_Carousel_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

/**
* | output |
* | --- |
* | "Next slide" |
*
* @param {Ui_Carousel_NextInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const ui_carousel_next = /** @type {((inputs?: Ui_Carousel_NextInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Carousel_NextInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ui_carousel_next(inputs)
	if (locale === "ms") return ms_ui_carousel_next(inputs)
	if (locale === "da") return da_ui_carousel_next(inputs)
	if (locale === "de") return de_ui_carousel_next(inputs)
	if (locale === "en-US") return en_us2_ui_carousel_next(inputs)
	if (locale === "es-ES") return es_es2_ui_carousel_next(inputs)
	if (locale === "es-MX") return es_mx2_ui_carousel_next(inputs)
	if (locale === "fil") return fil_ui_carousel_next(inputs)
	if (locale === "fr") return fr_ui_carousel_next(inputs)
	if (locale === "it") return it_ui_carousel_next(inputs)
	if (locale === "hu") return hu_ui_carousel_next(inputs)
	if (locale === "nl") return nl_ui_carousel_next(inputs)
	if (locale === "no") return no_ui_carousel_next(inputs)
	if (locale === "pl") return pl_ui_carousel_next(inputs)
	if (locale === "pt-BR") return pt_br2_ui_carousel_next(inputs)
	if (locale === "pt") return pt_ui_carousel_next(inputs)
	if (locale === "ro") return ro_ui_carousel_next(inputs)
	if (locale === "fi") return fi_ui_carousel_next(inputs)
	if (locale === "sv") return sv_ui_carousel_next(inputs)
	if (locale === "vi") return vi_ui_carousel_next(inputs)
	if (locale === "tr") return tr_ui_carousel_next(inputs)
	if (locale === "cs") return cs_ui_carousel_next(inputs)
	if (locale === "bg") return bg_ui_carousel_next(inputs)
	if (locale === "ru") return ru_ui_carousel_next(inputs)
	if (locale === "uk") return uk_ui_carousel_next(inputs)
	if (locale === "ar") return ar_ui_carousel_next(inputs)
	if (locale === "hi") return hi_ui_carousel_next(inputs)
	if (locale === "th") return th_ui_carousel_next(inputs)
	if (locale === "ja") return ja_ui_carousel_next(inputs)
	if (locale === "zh-CN") return zh_cn2_ui_carousel_next(inputs)
	if (locale === "zh-Hant") return zh_hant1_ui_carousel_next(inputs)
	return ko_ui_carousel_next(inputs)
});
export { ui_carousel_next as "ui.carousel.next" }